"use strict";
var AsyncScheduler_1 = require('./AsyncScheduler');
exports.async = new AsyncScheduler_1.AsyncScheduler();
//# sourceMappingURL=async.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/scheduler/async.js
 ** module id = 448
 ** module chunks = 2
 **/